/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Itinerary } from './Itinerary';
import {
    ItineraryFromJSON,
    ItineraryFromJSONTyped,
    ItineraryToJSON,
    ItineraryToJSONTyped,
} from './Itinerary';

/**
 * 
 * @export
 * @interface SearchItineraries200ResponseResultsInner
 */
export interface SearchItineraries200ResponseResultsInner {
    /**
     * 
     * @type {Itinerary}
     * @memberof SearchItineraries200ResponseResultsInner
     */
    entity?: Itinerary;
    /**
     * Relevance score (0-1)
     * @type {number}
     * @memberof SearchItineraries200ResponseResultsInner
     */
    score?: number;
    /**
     * Fields that matched the search query
     * @type {Array<string>}
     * @memberof SearchItineraries200ResponseResultsInner
     */
    matchedFields?: Array<string>;
    /**
     * Highlighted excerpts from matched fields
     * @type {{ [key: string]: string; }}
     * @memberof SearchItineraries200ResponseResultsInner
     */
    highlights?: { [key: string]: string; };
}

/**
 * Check if a given object implements the SearchItineraries200ResponseResultsInner interface.
 */
export function instanceOfSearchItineraries200ResponseResultsInner(value: object): value is SearchItineraries200ResponseResultsInner {
    return true;
}

export function SearchItineraries200ResponseResultsInnerFromJSON(json: any): SearchItineraries200ResponseResultsInner {
    return SearchItineraries200ResponseResultsInnerFromJSONTyped(json, false);
}

export function SearchItineraries200ResponseResultsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchItineraries200ResponseResultsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'entity': json['entity'] == null ? undefined : ItineraryFromJSON(json['entity']),
        'score': json['score'] == null ? undefined : json['score'],
        'matchedFields': json['matchedFields'] == null ? undefined : json['matchedFields'],
        'highlights': json['highlights'] == null ? undefined : json['highlights'],
    };
}

  export function SearchItineraries200ResponseResultsInnerToJSON(json: any): SearchItineraries200ResponseResultsInner {
      return SearchItineraries200ResponseResultsInnerToJSONTyped(json, false);
  }

  export function SearchItineraries200ResponseResultsInnerToJSONTyped(value?: SearchItineraries200ResponseResultsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entity': ItineraryToJSON(value['entity']),
        'score': value['score'],
        'matchedFields': value['matchedFields'],
        'highlights': value['highlights'],
    };
}

